module.exports = __webpack_public_path__ + "img/logo.bda33571.png";